import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ProfileSkill } from '../../../../../shared/models/profile-skill';
import { CandidateStore } from '../../../../store/candidate-store';

@Component({
  selector: 'app-skills-form',
  templateUrl: './skills-form.component.html',
  styleUrls: ['./skills-form.component.scss']
})
export class SkillsFormComponent implements OnInit {
  @Input() collapse_skills: boolean;

  form: FormGroup;
  constructor(private formBuilder: FormBuilder, public dashboardState: CandidateStore) {
  }

  ngOnInit() {
    this.form = this.formBuilder.group(
      {
        title: [''],
        level: ['']
      }
    );

  }

  public add(): void {
    if(!this.form.valid) {
      return;
    }

    if(this.form.value.title)
    {
      let skill = ProfileSkill.parseForm(this.form);
      this.dashboardState.updateListSkill(skill);
    }

    this.dashboardState.addSkill(new ProfileSkill());
  }

  public remove(index: number): void {
    this.dashboardState.removeSkill(index);
  }

  public save(): void {}

}
